var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-nav-bar'),_vm._t("default"),_c('app-footer'),_c('app-back-to-top')],2)}
var staticRenderFns = []

export { render, staticRenderFns }